// extracted by mini-css-extract-plugin
export default {"Wrapper":"SignIn_Wrapper__Odze7","Logo":"SignIn_Logo__RZ858"};